import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
// import {
//   changeCurrentMemberMenu,
//   screenChange
// } from "../../store/screenSlice";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LinearProgress, TextField, Typography } from "@mui/material";
import {
  updateEvent,
  deleteCostInfo,
  deleteLocationInfo,
  clearVideoURL,
  clearMaterialURL,
  // IEvent,
} from "../../store/eventApiSlice";
// import { DevTool } from "@hookform/devtools";
import CurrencyInput from "react-currency-input-field";
import deleteIcon from "./../../Images/Delete.png";
import { useNavigate } from "react-router-dom";
import {
  useForm,
  Controller,
  // useFormContext,
  // Merge,
  // FieldError,
  // FieldErrorsImpl,
} from "react-hook-form";
import { Button, PageLink } from "../StyledComp/StyledComp";
import { DateValidationError } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
// import { all } from "axios";
// import { invalid } from "moment";
import ReactModal from "react-modal";
import MemberServices from "../../services/MemberServices";
import EventServices from "../../services/EventServices";
import AddCostInfo from "./AddCostInfo";
import AddLocationInfo from "./AddLocationInfo";
// import { screenConfig } from "../../config/screenConfig";
import * as routeConfig from "../../config/routes";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import DeleteIcon from "@mui/icons-material/Delete";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import YesNoAlert from "../utilityComponents/YesNoAlert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileRejection, useDropzone } from "react-dropzone";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { FormatUtils } from "../util/FormatUtils";

type FormValues = {
  EventName: string;
  Description: string;
  UniqueEventId: string;
  EventType: string;
  EventCategory: string;
  StartDateTime: string;
  EndDateTime: string;
  EarlyBirdBy: string;
  Available: number;
  AvailableOnline: string;
  SponsorName: string;
  RegistrationLink: string;
  ZoomMeetingID: string;
  ZoomRegLink: string;
  DECredits: number;
  DEEnchEthics: number;
  PACredits: number;
  PAEthics: number;
  NJCredits: number;
  NJEthics: number;
  Comments: string;
  MaterialLink: string;
  Location: string;
  LocationCost: number;
  CostName: string;
  CostNameCost: number;
  MemberCostPerHour: number;
  NonMemberCostPerHour: number;
  MemberCost: number;
  NonMemberCost: number;
};

type FormValues1 = {
  CostName: string;
  CostNameCost: number;
};

interface IConfiguration {
  [key: string]: any;
}

// interface Cost {
//   Id: number | null;
//   CostName: string | null;
//   Cost: number | null;
// }

const EditEvent: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // dispatch(screenChange("Events"));

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const form = useForm<FormValues>();
  const formCost = useForm<FormValues1>({ mode: "onSubmit" });
  const { register, control, handleSubmit, formState, setValue } = form;
  const { errors } = formState;
  const [materialURL, setmaterialURL] = useState("");

  // const {
  //   register: registerCost,
  //   control: controlCost,
  //   handleSubmit: handleSubmitCost,
  //   formState: { errors: errorsCost },
  //   setValue: setValueCost,
  // } = formCost;

  // const { errors: errorsCost } = formStateCost;

  const eventInfo = useSelector(
    (state: RootState) => state.eventapislice.event
  );
  // const [editEventInfo, setEditEventInfo] = useState<IEvent>(eventInfo);
  console.log("event-editEvent:", eventInfo);

  // const [EventCostList, setEventCostList] = useState<Cost[] | null>(
  //   eventInfo.Costs
  // );

  // const [error, setError] = React.useState<DateValidationError | null>(null);
  const [CostModalOpen, setCostModalOpen] = useState<boolean>(false);
  const [LocationModalOpen, setLocationModalOpen] = useState<boolean>(false);

  /* ----use config list as temporary place holder for cost name  */
  const [costDesc, setcostDesc] = useState<IConfiguration>([]);

  const [uniqueEventId, setUniqueEventId] = useState<string>("");
  const [registrationLink, setRegistrationLink] = useState<string>("");
  const [materialLink, setMaterialLink] = useState<string>("");

  useEffect(() => {
    const getConfigurationLists = async () => {
      console.log("getConfigurationLists called");

      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data.MemberCode);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        setcostDesc(response.data.data.MemberCode);
      } else {
      }
    };

    getConfigurationLists();

    const initRequiredDateFields = () => {
      if (dayjs(eventInfo.StartDateTime).isValid()) {
        const passedDateUTCTime = dayjs
          .tz(eventInfo.StartDateTime, "America/New_York")
          .format("YYYY-MM-DDTHH:mm:ss");

        setValue(
          "StartDateTime",
          //dayjs(eventInfo.StartDateTime!).format("YYYY-MM-DD HH:mm:ss"),
          passedDateUTCTime,
          {
            shouldDirty: true,
          }
        );

        console.log("eventInfo.StartDateTime:", eventInfo.StartDateTime);
        // const utcStartDateTime = dayjs
        //   .tz(eventInfo.StartDateTime!, "America/New_York")
        //   .utc()
        //   .format("YYYY-MM-DDTHH:mm:ss");
        // console.log("utcStartDateTime:", utcStartDateTime);

        dispatch(
          updateEvent({
            key: "StartDateTime",
            // value: utcStartDateTime,
            value: passedDateUTCTime,
            // value: dayjs(eventInfo.StartDateTime!).format(
            //   "YYYY-MM-DD HH:mm:ss"
            // ),
          })
        );
      }
      // if (dayjs(dateOfBirth).isValid()) {
      //   form.setValue("DateOfBirth", dateOfBirth!.format("YYYY-MM-DD"));
      // }

      if (dayjs(eventInfo.EndDateTime).isValid()) {
        const passedDateUTCTime = dayjs
          .tz(eventInfo.EndDateTime, "America/New_York")
          .format("YYYY-MM-DDTHH:mm:ss");

        setValue(
          "EndDateTime",
          //dayjs(eventInfo.EndDateTime!).format("YYYY-MM-DD HH:mm:ss"),
          passedDateUTCTime,
          {
            shouldDirty: true,
          }
        );

        console.log("eventInfo.EndDateTime:", eventInfo.EndDateTime);
        // const utcEndDateTime = dayjs
        //   .tz(eventInfo.EndDateTime!, "America/New_York")
        //   .utc()
        //   .format("YYYY-MM-DDTHH:mm:ss");

        dispatch(
          updateEvent({
            key: "EndDateTime",
            value: passedDateUTCTime,
            // value: utcEndDateTime,
            // value: dayjs(eventInfo.EndDateTime!).format("YYYY-MM-DD HH:mm:ss"),
          })
        );
        // console.log("utcEndDateTime:", utcEndDateTime);
      }

      if (dayjs(eventInfo.EarlyBirdBy).isValid()) {
        const passedDateUTCTime = dayjs
          .tz(eventInfo.EarlyBirdBy, "America/New_York")
          .format("YYYY-MM-DDTHH:mm:ss");

        setValue(
          "EarlyBirdBy",
          // dayjs(eventInfo.EarlyBirdBy!).format("YYYY-MM-DD HH:mm:ss"),
          passedDateUTCTime,
          {
            shouldDirty: true,
          }
        );

        console.log("eventInfo.EarlyBirdBy:", eventInfo.EarlyBirdBy);
        // const EarlyBirdBy = dayjs
        //   .tz(eventInfo.EarlyBirdBy!, "America/New_York")
        //   .utc()
        //   .format("YYYY-MM-DDTHH:mm:ss");
        // console.log("EarlyBirdBy:", EarlyBirdBy);

        dispatch(
          updateEvent({
            key: "EarlyBirdBy",
            // value: utcStartDateTime,
            value: passedDateUTCTime,
            // value: dayjs(eventInfo.StartDateTime!).format(
            //   "YYYY-MM-DD HH:mm:ss"
            // ),
          })
        );
      }

      console.log(
        "StartDateTime and isValid()",
        eventInfo.StartDateTime,
        "-",
        dayjs(eventInfo.StartDateTime).isValid()
      );
    };
    initRequiredDateFields();
  }, []);

  // const [EventName, setEventName] = useState(eventInfo?.EventName);
  // const [Description, setDescription] = useState(eventInfo?.Description);
  // const [UniqueEventId, setUniqueEventId] = useState(eventInfo?.UniqueEventId);
  // const [EventType, setEventType] = useState(eventInfo?.EventType);
  // const [EventCategory, setEventCategory] = useState(eventInfo?.EventCategory);
  const [StartDateTime, setStartDateTime] = useState<Dayjs>(
    dayjs(eventInfo?.StartDateTime)!
  );
  const [EndDateTime, setEndDateTime] = useState<Dayjs>(
    dayjs(eventInfo?.EndDateTime)!
  );
  const [EarlyBirdBy, setEarlyBirdBy] = useState<Dayjs>(
    dayjs(eventInfo?.EarlyBirdBy)!
  );
  const [eventType, seteventType] = useState<string>();
  const [videoURL, setvideoURL] = useState(null);
  const [uploaded, setUploaded] = useState<number>(0);
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [videoUploadModalOpen, setvideoUploadModalOpen] =
    useState<boolean>(false);
  const [materialUploadModalOpen, setMaterialUploadModalOpen] =
    useState<boolean>(false);
  const [YesNoMaterialAlertModalOpen, setYesNoMaterialAlertModalOpen] =
    useState<boolean>(false);
  const [YesNoAlertModalOpen, setYesNoAlertModalOpen] =
    useState<boolean>(false);

  const [videoUploaded, setVideoUploaded] = useState<number>(0);
  const [materialUploaded, setMaterialUploaded] = useState<number>(0);
  // const [EarlyBirdBy, setEarlyBirdBy] = useState(eventInfo?.EarlyBirdBy);
  // const [Available, setAvailable] = useState(eventInfo?.Available);
  // const [AvailableOnline, setAvailableOnline] = useState(
  //   eventInfo?.AvailableOnline
  // );
  // const [SponsorName, setSponsorName] = useState(eventInfo?.SponsorName);
  // const [RegistrationLink, setRegistrationLink] = useState(
  //   eventInfo?.RegistrationLink
  // );
  // const [ZoomMeetingID, setZoomMeetingID] = useState(eventInfo?.ZoomMeetingID);
  // const [ZoomRegLink, setZoomRegLink] = useState(eventInfo?.ZoomRegLink);
  // const [DECredits, setDECredits] = useState(eventInfo?.DECredits);
  // const [DEEnchEthics, setDEEnchEthics] = useState(eventInfo?.DEEnchEthics);
  // const [PACredits, setPACredits] = useState(eventInfo?.PACredits);
  // const [PAEthics, setPAEthics] = useState(eventInfo?.PAEthics);
  // const [Comments, setComments] = useState(eventInfo?.Comments);
  // const [MaterialLink, setMaterialLink] = useState(eventInfo?.MaterialLink);
  // const [Location, setLocation] = useState(eventInfo?.Locations?.Location);
  // const [LocationCost, setLocationCost] = useState(eventInfo?.Locations?.Cost);
  // const [CostName, setCostName] = useState(eventInfo?.Costs?.CostName);
  // const [CostNameCost, setCostNameCost] = useState(eventInfo?.Costs?.Cost);

  const onVideoDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (fileRejections.length > 0) {
        alert("Only MP4 or WebM files are allowed!");
      } else if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        uploadVideo(file);
      }
      console.log("acceptedFiles", acceptedFiles);
    },
    [eventInfo]
  );

  const onDocuDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (fileRejections.length > 0) {
        alert("Only pdf files are allowed!");
      } else if (acceptedFiles.length > 0) {
        uploadMaterial(acceptedFiles[0]);
      }
      console.log(acceptedFiles);
    },
    [eventInfo]
  );

  const {
    getRootProps: getRootPropsVideo,
    getInputProps: getInputPropsVideo,
    isDragActive: isDragActiveVideo,
  } = useDropzone({
    onDrop: onVideoDrop,
    accept: {
      "video/mp4": [".mp4"],
      "video/webm": [".webm"],
    },
  });

  const {
    getRootProps: getRootPropsDocu,
    getInputProps: getInputPropsDocu,
    isDragActive: isDragActiveDocu,
  } = useDropzone({
    onDrop: onDocuDrop,
    accept: {
      pdf: [".pdf"],
      // document: [".docx"],
    },
  });

  const updateInput = (event: any): void => {
    console.log("key:", event.target.name, "value:", event.target.value);

    switch (event.target.name) {
      case "EventName":
        dispatch(
          updateEvent({
            key: "EventName",
            value: event.target.value,
          })
        );
        setRegistrationLink(
          "https://www.dsba.org/event/" + FormatUtils.toUrlSlug(event.target.value)
        );
        dispatch(
          updateEvent({
            key: "RegistrationLink",
            value:
              "https://www.dsba.org/event/" +
              FormatUtils.toUrlSlug(event.target.value),
          })
        );
        break;
      case "UniqueEventId":
        setUniqueEventId(event.target.value.replace(/\s/g, ""));
        // setMaterialLink(
        //   "https:/www.dsba.org/materials/?Cleid=" +
        //     event.target.value.replace(/\s/g, "")
        // );
        // dispatch(
        //   updateEvent({
        //     key: "MaterialLink",
        //     value:
        //       "https:/www.dsba.org/materials/?Cleid=" +
        //       event.target.value.replace(/\s/g, ""),
        //   })
        // );
        break;
      case "EventType":
        seteventType(event.target.value);
        break;
      // case "videos":
      //   const formData = new FormData();
      //   formData.append("media", event.target.files[0]);
      //   formData.append("id", "17");
      //   uploadVideo(formData);
      //   break;
      case "AvailableOnline":
        dispatch(
          updateEvent({
            key: "AvailableOnline",
            value: event.target.checked ? 1 : 0,
          })
        );
        break;
      case "MemberCostPerHour":
        console.log("update MemberCostPerHour");
        dispatch(
          updateEvent({
            key: "MemberCostPerHour",
            value: event.target.value,
          })
        );
        break;
      case "NonMemberCostPerHour":
        dispatch(
          updateEvent({
            key: "NonMemberCostPerHour",
            value: event.target.value,
          })
        );
        break;
      case "MemberCost":
        dispatch(
          updateEvent({
            key: "MemberCost",
            value: event.target.value,
          })
        );
        break;
      case "NonMemberCost":
        dispatch(
          updateEvent({
            key: "NonMemberCost",
            value: event.target.value,
          })
        );
        break;
      default:
        dispatch(
          updateEvent({
            key: event.target.name,
            value: event.target.value,
          })
        );
        break;
    }
  };

  const onProgressVideo = (data: any) => {
    // Access and handle the progress data in your component
    setVideoUploaded(Math.round((data.loaded / data.total) * 100));
  };

  // const uploadVideo = async (event: any) => {
  const uploadVideo = async (file: File) => {
    setvideoUploadModalOpen(true);
    const formData = new FormData();
    formData.append("media", file);
    formData.append("id", "17");
    console.log("uploadVideo CALLED");
    if (eventInfo.UniqueEventId) {
      const parentEventId = eventInfo.UniqueEventId.replace(/^./, "");
      console.log("uploadVideo CALLED:", parentEventId);
      const response = await EventServices.UploadVideo(
        formData,
        parentEventId,
        onProgressVideo
      );
      console.log("response", response);

      dispatch(
        updateEvent({
          key: "VideoURL",
          value: response?.data.data.media_url,
        })
      );
    } else {
      alert("Please enter event id");
      return;
    }
  };

  const onProgressMaterial = (data: any) => {
    // Access and handle the progress data in your component
    setMaterialUploaded(Math.round((data.loaded / data.total) * 100));
  };

  const uploadMaterial = async (file: File) => {
    console.log("uploadMaterial CALLED");
    setMaterialUploadModalOpen(true);
    const formData = new FormData();
    formData.append("media", file);
    formData.append("id", "1");

    if (eventInfo.UniqueEventId) {
      const response = await EventServices.UploadMaterial(
        formData,
        eventInfo.UniqueEventId,
        onProgressMaterial
      );
      console.log("response", response);
      // setvideoURL(response?.data.data.media_url);

      dispatch(
        updateEvent({
          key: "MaterialLink",
          value: response?.data.data.media_url,
        })
      );
    } else {
      alert("Please enter event id");
      return;
    }
  };

  const updateTextField = (event: any): void => {
    console.log("key:", event.target.name, "value:", event.target.value);
    console.log("Event Type:", event);
    dispatch(
      updateEvent({
        key: event.target.name,
        value: event.target.value,
      })
    );
  };

  const updateDateField = (passedDate: Dayjs, type: string) => {
    console.log("updateDateField B", passedDate, type);
    /* const passedDateUTCTime =  dayjs
        .tz(passedDate, "America/New_York")
        .format("YYYY-MM-DDTHH:mm:ss") */
    const passedDateUTCTime = passedDate;
    console.log("updateDateField A", passedDateUTCTime, type);
    /* if (dayjs(passedDate).isValid()) {
      const passedDateUTCTime = dayjs
        .tz(passedDate, "America/New_York")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");

      dispatch(
        updateEvent({
          key: type,
          value: passedDateUTCTime,
          // value: dayjs(passedDate!, "YYYY-MM-DD HH:mm:ss").format(
          // "YYYY-MM-DD HH:mm:ss"
          // ),
        })
      );
      const utcEndDateTime = dayjs
        .tz(eventInfo.EndDateTime!, "America/New_York")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");

      dispatch(
        updateEvent({
          key: "EndDateTime",
          value: utcEndDateTime,
          // value: dayjs(eventInfo.EndDateTime!).format("YYYY-MM-DD HH:mm:ss"),
        })
      );
    } */
    switch (type) {
      case "StartDateTime":
        if (dayjs(passedDate).isValid()) {
          const passedDateUTCTime = dayjs
            .tz(passedDate, "America/New_York")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss");
          setValue("StartDateTime", passedDateUTCTime, {
            shouldDirty: true,
          });
          dispatch(
            updateEvent({
              key: type,
              value: passedDateUTCTime,
              // value: dayjs(passedDate!, "YYYY-MM-DD HH:mm:ss").format(
              // "YYYY-MM-DD HH:mm:ss"
              // ),
            })
          );
          // const tempEndDate = new Date(dayjs(passedDate));
          // newDate.setHours(newDate.getHours() + 4);
          // setValue(
          //   "EndDateTime",
          //   dayjs(passedDate!, "YYYY-MM-DD HH:mm:ss")
          //     .add(4, "hour")
          //     .format("YYYY-MM-DD HH:mm:ss"),
          //   {
          //     shouldDirty: true,
          //   }
          // );
          // const passedDateUTCTime = dayjs
          //   .tz(passedDate, "America/New_York")
          //   .add(4, "hour")
          //   .utc()
          //   .format("YYYY-MM-DDTHH:mm:ss");
          // dispatch(
          //   updateEvent({
          //     key: "EndDateTime",
          //     value: dayjs(passedDateUTCTime!, "YYYY-MM-DD HH:mm:ss")
          //       .add(4, "hour")
          //       .format("YYYY-MM-DD HH:mm:ss"),
          //   })
          // );
          // setEndDateTime(
          //   dayjs(passedDate!).add(4, "hour").format("YYYY-MM-DD HH:mm:ss")
          // );
        } else {
          setValue("StartDateTime", "", {
            shouldDirty: true,
          });
        }
        break;
      case "EndDateTime":
        if (dayjs(passedDate).isValid()) {
          const passedDateUTCTime = dayjs
            .tz(passedDate, "America/New_York")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss");
          setValue("EndDateTime", passedDateUTCTime, {
            shouldDirty: true,
          });
          dispatch(
            updateEvent({
              key: "EndDateTime",
              value: passedDateUTCTime,
              // value: dayjs(eventInfo.EndDateTime!).format("YYYY-MM-DD HH:mm:ss"),
            })
          );
        } else {
          setValue("EndDateTime", "", {
            shouldDirty: true,
          });
        }
        break;
      case "EarlyBirdBy":
        if (dayjs(passedDate).isValid()) {
          const passedDateUTCTime = dayjs
            .tz(passedDate, "America/New_York")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss");
          setValue("EarlyBirdBy", passedDateUTCTime, {
            shouldDirty: true,
          });
          dispatch(
            updateEvent({
              key: "EarlyBirdBy",
              value: passedDateUTCTime,
              // value: dayjs(eventInfo.EndDateTime!).format("YYYY-MM-DD HH:mm:ss"),
            })
          );
        } else {
          setValue("EarlyBirdBy", "", {
            shouldDirty: true,
          });
        }
        break;
      default:
        console.log("default case");
        break;
    }
  };

  // const onAddCostItem = (e: any) => {
  //   console.log("onAddCostItem");
  //   console.log("onAddCostItem:", e);
  // };

  const onSubmit = async (d: any) => {
    console.log("SUBMIT");

    // if (!StartDateTime) {
    //   console.log("INVALID DATE");
    //   return;
    // }
    // if (!EndDateTime) {
    //   console.log("INVALID DATE");
    //   return;
    // }

    console.log("editEventBody", eventInfo);
    const response = await EventServices.editEvent(eventInfo);
    console.log("response", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Event updated successfully");
      // dispatch(assignCurrentMember(response.data.data[0]));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
    } else {
      console.log("error");
    }

    // dispatch(changeCurrentMemberMenu(screenConfig.viewEvent));
    navigate(routeConfig.EVENT_DETAIL_URL, { replace: false });
  };

  const closeCostModal = (flag: boolean) => {
    console.log("isModelOpen:", CostModalOpen);
    setCostModalOpen(flag);
  };

  const closeLocationModal = (flag: boolean) => {
    console.log("isModelOpen:", LocationModalOpen);
    setLocationModalOpen(flag);
  };

  // const deleteVideoURL = () => {
  //   dispatch(clearVideoURL());
  // };

  const handleDelete = (e: any, infoType: string) => {
    console.log("HANDLE DELETE");
    console.log("onDelete:", e);
    const keyValue = e.currentTarget.getAttribute("data-key");
    console.log("Key Value:", keyValue);
    console.log("infoType:", infoType);
    if (infoType == "Cost")
      dispatch(
        deleteCostInfo({
          key: "Costs",
          value: keyValue,
        })
      );
    if (infoType == "Location")
      dispatch(
        deleteLocationInfo({
          key: "Locations",
          value: keyValue,
        })
      );
  };

  const cancelEvent = () => {
    // dispatch(changeCurrentMemberMenu(screenConfig.viewEvent));
    navigate(routeConfig.EVENT_DETAIL_URL, { replace: false });
  };

  const color1 = "#2d6289";

  // const muiTextFieldTheme
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              // borderBottomStyle: "solid",
              // borderBottomWidth: 1,
              boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
              paddingTop: "20px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "0px",
              fontWeight: "400",
              color: "black",
              "&.Mui-disabled": {
                backgroundColor: "var(--form-input-background-color)",
                color: color1,
              },
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
              color: color1,
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              // marginBottom: "1.8rem",
            },
          },
        },
        MuiTextArea: {
          styleOverrides: {
            root: {
              // marginBottom: "1.8rem",
            },
          },
        },
      },
    });

  const handleFileUploadButtonClick = () => {
    const fileInput = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement | null;
    if (fileInput) {
      fileInput.click();
    }
  };

  // Function to copy link to clipboard
  const copyToClipboard = (type: string) => {
    if (type === "VideoURL" && eventInfo && eventInfo.VideoURL) {
      navigator.clipboard.writeText(eventInfo.VideoURL).then(
        () => {
          toast("Link copied to clipboard!");
        },
        (err) => {
          toast("Failed to copy: ", err);
        }
      );
    }
    if (type === "MaterialLink" && eventInfo && eventInfo.MaterialLink) {
      navigator.clipboard.writeText(eventInfo.MaterialLink).then(
        () => {
          toast("Link copied to clipboard!");
        },
        (err) => {
          toast("Failed to copy: ", err);
        }
      );
    }
  };

  const deleteVideoURL = (YesorNo: boolean) => {
    console.log("deleteVideoURL called:", YesorNo);
    if (YesorNo) {
      dispatch(clearVideoURL());
      // alert("Uploaded video Deleted Succefully");
      toast("Uploaded video Deleted Succefully");
    }
    setYesNoAlertModalOpen(false);
  };

  const deleteMaterialURL = (YesorNo: boolean) => {
    console.log("deleteMaterialURL called:", YesorNo);
    if (YesorNo) {
      dispatch(clearMaterialURL());
      toast("Uploaded Material Deleted Succefully");
    }
    setYesNoMaterialAlertModalOpen(false);
  };

  return (
    <div
      className="dashboard-content-wrapper"
      style={{ marginBottom: "100px" }}
    >
      <ToastContainer />
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Edit Event</h1>
        <div
          style={{ cursor: "pointer", paddingRight: "0rem", color: "blue" }}
          onClick={cancelEvent}
        >
          <PageLink>Cancel </PageLink>
        </div>
      </div>
      <form
        key={1}
        className="form-wrapper"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        {/* ----------Event Information------------ */}
        <div className="section-box">
          <h3 className="section-heading">Event Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                placeholder=""
                id="EventName"
                {...register("EventName", {
                  required: "* required field",
                })}
                value={eventInfo.EventName as string}
                readOnly={
                  eventInfo.EventType === "Video" ||
                  eventInfo.ChildEventId !== null
                    ? true
                    : false
                }
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="EventName">
                Event Name{" "}
                {eventInfo.EventType === "Video" ||
                eventInfo.ChildEventId !== null
                  ? "(Read only)"
                  : ""}
              </label>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.EventName?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                placeholder=""
                id="UniqueEventId"
                {...register("UniqueEventId", {
                  required: "* required field",
                })}
                value={eventInfo.UniqueEventId as string}
                autoComplete="off"
                readOnly={
                  eventInfo.EventType === "Video" ||
                  eventInfo.ChildEventId !== null
                    ? true
                    : false
                }
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="UniqueEventId">
                Event ID{" "}
                {eventInfo.EventType === "Video" ||
                eventInfo.ChildEventId !== null
                  ? "(Read only)"
                  : ""}
              </label>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.UniqueEventId?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper-smallest">
              <select
                className="dropdown-control-large-insidetextfield"
                id="EventType"
                name="EventType"
                // placeholder=""
                style={{ color: "#25284e" }}
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.EventType ?? ""}
                disabled={true}
              >
                <option value=""> Select Type </option>
                <option value="Function">Function</option>
                <option value="Seminar">Seminar</option>
                <option value="Video">Video</option>
              </select>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.EventType?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper-smaller">
              <Controller
                control={control}
                name="StartDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="Start Date"
                        value={dayjs(StartDateTime)}
                        slotProps={{
                          textField: {
                            error: Boolean(error),
                            helperText: error
                              ? errors.StartDateTime?.message?.toString()
                              : "",
                          },
                        }}
                        onChange={(date: any) => {
                          date && setStartDateTime(date);
                          updateDateField(date, "StartDateTime");
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>

            <div className="input-field-div-wrapper-smaller">
              <Controller
                control={control}
                name="EndDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="End Date"
                        value={dayjs(EndDateTime)}
                        slotProps={{
                          textField: {
                            error: Boolean(error),
                            helperText: error
                              ? errors.EndDateTime?.message?.toString()
                              : "",
                          },
                        }}
                        onChange={(date: any) => {
                          console.log("Date:", date);
                          date && setEndDateTime(date);
                          updateDateField(date, "EndDateTime");
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>
          </div>
          <div className="input-field-div-wrapper">
            <Controller
              control={control}
              name="EarlyBirdBy"
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      className="datepicker-local"
                      label="Early Bird By"
                      value={dayjs(EarlyBirdBy)}
                      slotProps={{
                        textField: {
                          error: Boolean(error),
                          helperText: error
                            ? errors.EarlyBirdBy?.message?.toString()
                            : "",
                        },
                      }}
                      onChange={(date: any) => {
                        console.log("Date:", date);
                        date && setEarlyBirdBy(date);
                        updateDateField(date, "EarlyBirdBy");
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>
          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <TextField
              className="textarea"
              id="Description"
              name="Description"
              placeholder="Event Description"
              multiline
              rows={3}
              value={eventInfo.Description as string}
              onChange={(e) => {
                updateTextField(e);
              }}
            />
          </div>

          {/* <div className="horizontal-wrapper-spacebetween">
            {eventInfo.EventType === "Video" ? (
              eventInfo.VideoURL === null ? (
                <>
                  <div
                    className="input-field-div-wrapper-large"
                    style={{
                      border: "2px",
                      borderStyle: "dashed",
                      borderColor: "#cccccc",
                      borderRadius: "4px",
                      background: "none",
                      height: "auto",
                    }}
                  >
                    <div
                      {...getRootPropsVideo({
                        onClick: (event) => {
                          event.stopPropagation();
                          event.preventDefault();
                        },
                      })}
                      className={`dropzone ${
                        isDragActiveVideo ? "active" : ""
                      }`}
                    >
                      <input {...getInputPropsVideo()} />
                      {isDragActiveVideo ? (
                        <>
                          <p>Drop the Video files here ...</p>
                          <small>use only .MP4 or .WebM</small>
                        </>
                      ) : (
                        <>
                          <p>
                            Drag 'n' drop some files here, or click "Add Video
                            File button"
                          </p>
                          <small>Only MP4, or WebM files are allowed</small>
                        </>
                      )}
                      <button
                        type="button"
                        className="button"
                        onClick={handleFileUploadButtonClick}
                      >
                        Add Video File
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="form-wrapper-vertical"
                    style={{
                      height: "auto",
                      width: "45%",
                    }}
                  >
                    <div
                      className="textarea-wrapper"
                      style={{ width: "100%", marginBottom: "0.5rem" }}
                    >
                      <TextField
                        className="textarea"
                        placeholder=""
                        id="videoURL"
                        name="videoURL"
                        autoComplete="off"
                        // readOnly={true}
                        multiline
                        rows={2}
                        value={eventInfo.VideoURL ?? ""}
                      />
                      <label
                        className="form-label"
                        htmlFor="VideoURL"
                        style={{
                          fontSize: "0.8rem",
                          fontWeight: "400",
                          top: "-0.5rem",
                          left: "0.5rem",
                          backgroundColor: "rgba(255, 255, 255, 100)",
                        }}
                      >
                        Video Link
                      </label>
                    </div>

                    <div className="horizontal-wrapper-rightaligned">
                      <div
                        style={{
                          width: "auto",
                          height: "2rem",
                          // backgroundColor: "green",
                        }}
                      >
                        <a href={eventInfo.VideoURL as string} target="_blank">
                          <PlayCircleOutlineIcon />
                          Play
                        </a>
                      </div>
                      <div
                        style={{
                          width: "auto",
                          height: "2rem",
                          display: "flex",
                          alignItems: "left",
                          cursor: "pointer",
                          color: "#1976d2",
                          paddingLeft: ".8rem",
                        }}
                        onClick={(string) => copyToClipboard("VideoURL")}
                      >
                        <a>
                          <CopyAllIcon />
                          Copy
                        </a>
                      </div>
                      <div
                        style={{
                          width: "auto",
                          height: "2rem",
                          color: "#1976d2",
                          paddingLeft: ".8rem",
                          cursor: "pointer",
                        }}
                        onClick={() => setYesNoAlertModalOpen(true)}
                      >
                        <a>
                          <DeleteIcon />
                          Delete
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              )
            ) : (
              <></>
            )}
            {
              // eventType === "MaterialLink" &&

              eventInfo.MaterialLink === null ? (
                <>
                  <div
                    className="input-field-div-wrapper-large"
                    style={{
                      border: "2px",
                      borderStyle: "dashed",
                      borderColor: "#cccccc",
                      borderRadius: "4px",
                      background: "none",
                      height: "auto",
                      width: eventInfo.EventType === "Video" ? "45%" : "100%",
                    }}
                  >
                    <div
                      {...getRootPropsDocu({
                        onClick: (event) => {
                          event.stopPropagation();
                          event.preventDefault();
                        },
                      })}
                      className={`dropzone ${isDragActiveDocu ? "active" : ""}`}
                    >
                      <input {...getInputPropsDocu()} />
                      {isDragActiveDocu ? (
                        <>
                          <p>Drop the Material here ...</p>
                          <small>use only .pdf</small>
                        </>
                      ) : (
                        <>
                          <p>
                            Drag 'n' drop files here, or click "Add Material
                            File button"
                          </p>
                          <small>use only .pdf</small>
                        </>
                      )}
                      <button
                        type="button"
                        className="button"
                        onClick={handleFileUploadButtonClick}
                      >
                        Add Material File
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div
                  className="form-wrapper-vertical"
                  style={{
                    height: "auto",
                    width: eventInfo.EventType === "Video" ? "45%" : "100%",
                  }}
                >
                  <div
                    className="textarea-wrapper"
                    style={{ width: "100%", marginBottom: "0.5rem" }}
                  >
                    <TextField
                      className="textarea"
                      placeholder=""
                      id="MaterialLink"
                      name="MaterialLink"
                      autoComplete="off"
                      // readOnly={true}
                      multiline
                      rows={2}
                      value={eventInfo.MaterialLink ?? ""}
                    />
                    <label
                      className="form-label"
                      htmlFor="MaterialLink"
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: "400",
                        top: "-0.5rem",
                        left: "0.5rem",
                        backgroundColor: "rgba(255, 255, 255, 100)",
                      }}
                    >
                      Material Link
                    </label>
                  </div>
                  <div className="horizontal-wrapper-rightaligned">
                    <div
                      style={{
                        width: "auto",
                        height: "2rem",
                        // backgroundColor: "green",
                      }}
                    >
                      <a
                        href={eventInfo.MaterialLink as string}
                        target="_blank"
                      >
                        <OpenInNewIcon />
                        View
                      </a>
                    </div>
                    <div
                      style={{
                        width: "auto",
                        height: "2rem",
                        display: "flex",
                        alignItems: "left",
                        cursor: "pointer",
                        color: "#1976d2",
                        paddingLeft: ".8rem",
                      }}
                      onClick={(string) => copyToClipboard("MaterialLink")}
                    >
                      <a>
                        <CopyAllIcon />
                        Copy
                      </a>
                    </div>
                    <div
                      style={{
                        width: "auto",
                        height: "2rem",
                        color: "#1976d2",
                        paddingLeft: ".8rem",
                        cursor: "pointer",
                      }}
                      onClick={() => setYesNoMaterialAlertModalOpen(true)}
                    >
                      <a>
                        <DeleteIcon />
                        Delete
                      </a>
                    </div>
                  </div>
                </div>
              )
            }
          </div> */}

          <div className="horizontal-wrapper-spacebetween">
            {/* <div
              className="input-field-div-wrapper"
              style={{ marginTop: "1rem", width: "45%" }}
            >
              <input
                className="input-field-div-small"
                placeholder=""
                id="videoURL"
                name="videoURL"
                autoComplete="off"
                value={eventInfo.VideoURL ?? ""}
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="SponsorName">
                Video Link
              </label>
            </div> */}

            {eventInfo.EventType === "Video" ? (
              <>
                <div
                  className="input-field-div-wrapper"
                  style={{ marginTop: "1rem", width: "45%" }}
                >
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="videoURL"
                    name="videoURL"
                    autoComplete="off"
                    value={eventInfo.VideoURL ?? ""}
                    onChange={(e) => {
                      updateInput(e);
                    }}
                  />
                  <label className="form-label" htmlFor="SponsorName">
                    Video Link
                  </label>
                </div>
              </>
            ) : (
              <></>
            )}

            <div
              className="input-field-div-wrapper"
              style={{ marginTop: "1rem", width: "45%" }}
            >
              <input
                className="input-field-div-small"
                placeholder=""
                id="MaterialLink"
                name="MaterialLink"
                autoComplete="off"
                value={eventInfo.MaterialLink ?? ""}
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="SponsorName">
                Material Link
              </label>
            </div>
          </div>

          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="RegistrationLink"
                {...register("RegistrationLink", {
                  required: "* required field",
                })}
                value={eventInfo.RegistrationLink as string}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="RegistrationLink">
                Registration Link
              </label>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.RegistrationLink?.message}
              </p>
            </div>
            {/* <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="SponsorName"
                name="SponsorName"
                value={eventInfo.SponsorName as string}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="SponsorName">
                Sponsor
              </label>
            </div> */}
          </div>
          <div className="horizontal-wrapper-spacebetween">
            {eventInfo.EventType !== "Video" ? (
              <>
                <div className="input-field-div-wrapper-large">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="ZoomMeetingID"
                    name="ZoomMeetingID"
                    autoComplete="off"
                    onChange={(e) => {
                      updateInput(e);
                    }}
                    value={eventInfo.ZoomMeetingID as string}
                  />
                  <label className="form-label" htmlFor="ZoomMeetingID">
                    Zoom Meeting ID
                  </label>
                </div>
                <div className="input-field-div-wrapper-large">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="ZoomRegLink"
                    name="ZoomRegLink"
                    autoComplete="off"
                    onChange={(e) => {
                      updateInput(e);
                    }}
                    value={eventInfo.ZoomRegLink as string}
                  />
                  <label className="form-label" htmlFor="ZoomRegLink">
                    Zoom Meeting Link
                  </label>
                </div>{" "}
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="form-group">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="AvailableOnline"
                  name="AvailableOnline"
                  checked={eventInfo.AvailableOnline === 1}
                  onChange={(e) => updateInput(e)}
                />
                <label
                  className="form-check-label"
                  htmlFor="AvailableOnline"
                >
                  Available for registration
                </label>
              </div>
            </div>
          </div>
        </div>
        {/* ----------Credit Information------------ */}
        <div className="section-box">
          <h3 className="section-heading">Credit Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DECredits"
                name="DECredits"
                value={eventInfo.DECredits as number}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="DECredits">
                DE Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DEEnchEthics"
                name="DEEnchEthics"
                value={eventInfo.DEEnchEthics as number}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="DEEnchEthics">
                DE Ethics
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PACredits"
                name="PACredits"
                value={eventInfo.PACredits as number}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="PACredits">
                PA Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PAEthics"
                name="PAEthics"
                value={eventInfo.PAEthics as number}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="PAEthics">
                PA Ethics
              </label>
            </div>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJCredits"
                name="NJCredits"
                value={eventInfo.NJCredits as number}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="NJCredits">
                NJ Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJEthics"
                name="NJEthics"
                value={eventInfo.NJEthics as number}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="NJEthics">
                NJ Ethics
              </label>
            </div>
          </div>
        </div>

        {/* ----------Function and Seminar Cost Information------------ */}
        {eventInfo.EventType !== "Video" ? (
          <div className="horizontal-wrapper-spacebetween">
            {/* ----------Cost Information------------ */}
            <div className="section-box" style={{ width: "48%" }}>
              <div className="horizontal-wrapper-spacebetween">
                <h3 className="section-heading">Cost Information</h3>
                <PageLink onClick={() => setCostModalOpen(true)}>
                  <span>+ADD</span>
                </PageLink>
              </div>
              <div className="horizontal-wrapper-spacebetween">
                {eventInfo.Costs != null ? (
                  eventInfo.Costs!.map((eventcostitem) => (
                    <div
                      className="form-wrapper-space-around "
                      key={eventcostitem.Id}
                    >
                      <div className="cost-name-extralarge">
                        {eventcostitem.CostName as string}
                      </div>
                      <div className="cost-name-smaller">
                        {eventcostitem.Cost as number}
                      </div>
                      <img
                        style={{
                          width: "1rem",
                          height: "1.2rem",
                          alignSelf: "center",
                        }}
                        src={deleteIcon}
                        alt="Del"
                        data-key={eventcostitem.Id}
                        onClick={(e) => {
                          handleDelete(e, "Cost");
                        }}
                      />
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            </div>

            {/* ----------Location Information------------ */}
            <div className="section-box" style={{ width: "48%" }}>
              <div className="horizontal-wrapper-spacebetween">
                <h3 className="section-heading">Location Information</h3>
                <PageLink onClick={() => setLocationModalOpen(true)}>
                  <span>+ADD</span>
                </PageLink>
              </div>
              <div className="horizontal-wrapper-spacebetween">
                {eventInfo.Locations != null ? (
                  eventInfo.Locations!.map((eventlocationitem) => (
                    <div
                      className="form-wrapper-space-around "
                      key={eventlocationitem.Id}
                    >
                      <div className="cost-name-extralarge">
                        {eventlocationitem.Location as string}
                      </div>
                      <div className="cost-name-smaller">
                        {eventlocationitem.Cost as number}
                      </div>
                      <img
                        style={{
                          width: "1rem",
                          height: "1.2rem",
                          alignSelf: "center",
                        }}
                        src={deleteIcon}
                        alt="Del"
                        data-key={eventlocationitem.Id}
                        onClick={(e) => {
                          handleDelete(e, "Location");
                        }}
                      />
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {/* ----------VIDEO Cost Edit------------ */}
        {eventInfo.EventType === "Video" ? (
          <>
            <h3 className="section-heading">Cost Information</h3>

            <div className="horizontal-wrapper-spacebetween">
              <div className="input-field-div-wrapper-smallnominwidth">
                <CurrencyInput
                  className="input-field-div-small"
                  id="MemberCostPerHour"
                  placeholder=""
                  value={eventInfo.MemberCostPerHour ?? 60}
                  // defaultValue={0}
                  {...register("MemberCostPerHour")}
                  decimalsLimit={2}
                  onChange={(e) => {
                    updateInput(e);
                  }}
                  // onValueChange={(value, name) => console.log(value, name)}
                />
                <label className="form-label" htmlFor="MemberCostPerHour">
                  Member Cost / Hour
                </label>
              </div>

              <div className="input-field-div-wrapper-smallnominwidth">
                <CurrencyInput
                  className="input-field-div-small"
                  id="NonMemberCostPerHour"
                  placeholder=""
                  value={eventInfo.NonMemberCostPerHour ?? 120}
                  // defaultValue={0}
                  {...register("NonMemberCostPerHour")}
                  decimalsLimit={2}
                  onChange={(e) => {
                    updateInput(e);
                  }}
                  // onValueChange={(value, name) => console.log(value, name)}
                />
                <label className="form-label" htmlFor="NonMemberCostPerHour">
                  Non Member Cost / Hour
                </label>
              </div>

              <div className="input-field-div-wrapper-smallnominwidth">
                <CurrencyInput
                  className="input-field-div-small"
                  id="MemberCost"
                  placeholder=""
                  value={eventInfo.MemberCost ?? 0}
                  // defaultValue={0}
                  {...register("MemberCost")}
                  decimalsLimit={2}
                  onChange={(e) => {
                    updateInput(e);
                  }}
                  // onValueChange={(value, name) => console.log(value, name)}
                />
                <label className="form-label" htmlFor="MemberCost">
                  Member Cost Online
                </label>
              </div>

              <div className="input-field-div-wrapper-smallnominwidth">
                <CurrencyInput
                  className="input-field-div-small"
                  id="NonMemberCost"
                  placeholder=""
                  value={eventInfo.NonMemberCost ?? 0}
                  // defaultValue={0}
                  {...register("NonMemberCost")}
                  decimalsLimit={2}
                  onChange={(e) => {
                    updateInput(e);
                  }}
                  // onValueChange={(value, name) => console.log(value, name)}
                />
                <label className="form-label" htmlFor="NonMemberCost">
                  Non Member Cost Online
                </label>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        {/* ----------Submit button Information------------ */}
        <div className="submit-floating-button-div">
          <Button
            className="submit-button-div"
            type="submit"
            disabled={
              eventInfo.EventType === "Video" && eventInfo.VideoURL === null
                ? true
                : false
            }
          >
            Save
          </Button>
        </div>
      </form>
      {/* cost modal */}
      <ReactModal
        isOpen={CostModalOpen}
        // onRequestClose={() => setCostModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add Cost Information
          </h1>
          <PageLink
            onClick={() => setCostModalOpen(false)}
            style={{ marginBottom: "2rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <AddCostInfo closeCostModal={closeCostModal} />
      </ReactModal>

      {/* Location modal */}
      <ReactModal
        isOpen={LocationModalOpen}
        // onRequestClose={() => setLocationModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add Location Information
          </h1>
          <PageLink
            onClick={() => setLocationModalOpen(false)}
            style={{ marginBottom: "2rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <AddLocationInfo closeLocationModal={closeLocationModal} />
      </ReactModal>

      {/* Video Upload progress */}
      <ReactModal
        isOpen={videoUploadModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            {eventInfo.VideoURL === null
              ? "Video Upload Inprogress"
              : "Upload Complete"}
          </h1>
        </div>
        <div className="uploadPercent" style={{ width: "10%", height: "100%" }}>
          <Typography variant="h3" color="secondary">
            {videoUploaded}%
          </Typography>
        </div>
        <div
          className="uploadProgress"
          style={{ width: "90%", height: "100%" }}
        >
          <LinearProgress
            variant="determinate"
            color="secondary"
            value={videoUploaded}
          />
        </div>

        <div className="button-wrapper" style={{ marginTop: "1rem" }}>
          <div className="submit-button-div">
            <Button
              type="submit"
              disabled={eventInfo.VideoURL === null ? true : false}
              onClick={() => setvideoUploadModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={materialUploadModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            {eventInfo.MaterialLink === null
              ? "Video Upload Inprogress"
              : "Upload Complete"}
          </h1>
        </div>
        <div className="uploadPercent" style={{ width: "10%", height: "100%" }}>
          <Typography variant="h3" color="secondary">
            {materialUploaded}%
          </Typography>
        </div>
        <div
          className="uploadProgress"
          style={{ width: "90%", height: "100%" }}
        >
          <LinearProgress
            variant="determinate"
            color="secondary"
            value={materialUploaded}
          />
        </div>

        <div className="button-wrapper" style={{ marginTop: "1rem" }}>
          <div className="submit-button-div">
            <Button
              type="submit"
              disabled={eventInfo.MaterialLink === null ? true : false}
              onClick={() => setMaterialUploadModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </ReactModal>

      {/* yes no Alert */}
      <ReactModal
        isOpen={YesNoAlertModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <YesNoAlert callBack={deleteVideoURL} />
      </ReactModal>

      {/* yes no Material Alert */}
      <ReactModal
        isOpen={YesNoMaterialAlertModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <YesNoAlert callBack={deleteMaterialURL} />
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default EditEvent;
